import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/background/profile.pic.jpg';
const _withScopeId = n => (_pushScopeId("data-v-56238782"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home flex-1 flex flex-col justify-center items-center"
};
const _hoisted_2 = {
  class: "banner flex flex-row justify-center items-center w-full"
};
const _hoisted_3 = {
  class: "intro flex flex-col w-1/2 text-left mr-8 text-lg"
};
const _hoisted_4 = {
  class: "flex flex-row items-center tracking-widest"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "block w-5 h-0.5 bg-gray-400 shadow-lg mr-2"
}, null, -1));
const _hoisted_6 = {
  class: "my-6"
};
const _hoisted_7 = {
  class: "name font-bold text-3xl"
};
const _hoisted_8 = {
  class: "mt-6 w-1/3 flex flex-row brightness-50"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "profile rounded saturate-50"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "profile",
  class: "w-28 rounded saturate-200 sm:w-56"
})], -1));
const _hoisted_11 = {
  class: "skills w-full py-12 flex flex-col"
};
const _hoisted_12 = {
  class: "title font-bold text-xl my-12"
};
const _hoisted_13 = {
  class: "w-full flex flex-1 flex-row justify-around items-center"
};
const _hoisted_14 = {
  class: "mb-5"
};
const _hoisted_15 = {
  class: "tools"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, [_hoisted_5, _createTextVNode(_toDisplayString(_ctx.$t("hi")), 1)]), _createElementVNode("h1", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("name")), 1)]), _createElementVNode("p", null, _toDisplayString(_ctx.$t("intro")), 1), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconList, item => {
    return _openBlock(), _createBlock(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: item.name,
      placement: "top",
      key: item.id
    }, {
      default: _withCtx(() => [_createElementVNode("a", {
        href: item.link,
        class: "mr-6"
      }, [_createElementVNode("span", {
        class: _normalizeClass(`icon iconfont ${item.class}`)
      }, null, 2)], 8, _hoisted_9)]),
      _: 2
    }, 1032, ["content"]);
  }), 128))])]), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("skills.title")), 1), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillObject, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.icon,
      class: "flex flex-col w-1/4 h-80 bg-background-box p-5 rounded"
    }, [_createElementVNode("span", {
      class: _normalizeClass(`icon iconfont ${item.icon} text-4xl m-3`)
    }, null, 2), _createElementVNode("h3", _hoisted_14, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_15, _toDisplayString(item.content), 1)]);
  }), 128))])])]);
}